export default "__VITE_ASSET__QelUdCU8bcxCVRLAGGs1Zw__"